import { Requester } from "./requester";

export interface Handshake {
  "interactions-enabled?": boolean;
  "rrweb-enabled?": boolean;
}

export const handshake = async (request: Requester): Promise<Handshake> => {
  const response = await request("pixel");
  return await response.json();
};
